import Image from 'next/image';
import Link from 'next/link';

import { Logo } from '../Logo';
import { Column, Row, Section } from '../Section';
import linkedInLogo from './linkedin.svg';
import facebookLogo from './facebook.svg';
import instagramLogo from './instagram.svg';
import twitterLogo from './twitter.svg';

export const Footer = () => (
  <footer>
    <Section
      background="DARK_GRAY"
      className="text-gray-100 hover:[&_a]:opacity-80"
    >
      <Row>
        <Column>
          <Logo white />
          <ul className="mt-3 text-xs font-medium space-y-3 md:space-y-1">
            <li>
              <a href="tel:1-800-797-0327">800-797-0327 (toll free)</a>
            </li>
            <li>
              <a href="tel:704-303-8256">704-303-8256</a>
            </li>
            <li>
              <a href="mailto:info@healthplansofnc.com">
                info@healthplansofnc.com
              </a>
            </li>
          </ul>
        </Column>
        <Column>
          <h2 className="text-gray-200 text-sm font-bold">Health Plans</h2>
          <ul className="text-sm font-medium space-y-2.5 md:space-y-1">
            <li>
              <Link href="/individual-family">Individual & Family</Link>
            </li>
            <li>
              <Link href="/medicare">Medicare</Link>
            </li>
            <li>
              <Link href="/dental">Dental</Link>
            </li>
            <li>
              <Link href="/group">Group</Link>
            </li>
            <li>
              <Link href="/quote">Get Quote</Link>
            </li>
          </ul>
        </Column>
        <Column>
          <h2 className="text-gray-200 text-sm font-bold">Company</h2>
          <ul className="text-sm font-medium space-y-2.5 md:space-y-1">
            <li>
              <Link href="/about">About</Link>
            </li>
            <li>
              <Link href="/agents">Meet our Agents</Link>
            </li>
            <li>
              <Link href="/careers">Careers</Link>
            </li>
            <li>
              <Link href="/articles/all">News</Link>
            </li>
          </ul>
        </Column>
        <Column>
          <h2 className="text-gray-200 text-sm font-bold">Community</h2>
          <ul className="text-sm font-medium space-y-2.5 md:space-y-1">
            <li>
              <Link href="https://www.linkedin.com/company/health-plans-of-north-carolina">
                <Image
                  src={linkedInLogo}
                  className="inline mr-2"
                  alt="LinkedIn"
                />
                LinkedIn
              </Link>
            </li>
            <li>
              <Link href="https://www.facebook.com/healthplansofnc">
                <Image
                  src={facebookLogo}
                  className="inline mr-2"
                  alt="Facebook"
                />
                Facebook
              </Link>
            </li>
            <li>
              <Link href="https://www.instagram.com/healthplansofnorthcarolina">
                <Image
                  src={instagramLogo}
                  className="inline mr-2"
                  alt="Instagram"
                />
                Instagram
              </Link>
            </li>
            <li>
              <Link href="https://twitter.com/HealthPlansofNC">
                <Image
                  src={twitterLogo}
                  className="inline mr-2"
                  alt="Twitter"
                />
                Twitter
              </Link>
            </li>
          </ul>
        </Column>
      </Row>
      <Row>
        <Column className="text-sm flex flex-col sm:flex-row items-start !space-y-2.5 sm:!space-y-0">
          <Link href="/privacy">Privacy Policy</Link>
          <span className="hidden sm:inline mx-2 text-gray-500"> | </span>
          <a href="https://www.bluecrossnc.com/about-us/policies-and-best-practices/non-discrimination-policy-and-accessibility-services">
            Non-Discrimination Policy & Accessibility
          </a>
        </Column>
      </Row>
      <Row>
        <Column className="text-gray-400 text-sm">
          <p>
            Health Plans of North Carolina, Inc. is an independent authorized
            agency licensed to sell and promote products from Blue Cross and
            Blue Shield of North Carolina (Blue Cross NC). The content contained
            in this site is maintained by Health Plans of North Carolina, Inc.
            Blue Cross and Blue Shield of North Carolina is an independent
            licensee of the Blue Cross and Blue Shield Association.
          </p>
          <p>
            ® Registered mark of the Blue Cross and Blue Shield Association SM
            Service mark of the Blue Cross and Blue Shield Association © Health
            Plans of North Carolina, Inc. Blue Cross Blue Shield of North
            Carolina®
          </p>
        </Column>
      </Row>
    </Section>
  </footer>
);
